export default __webpack_public_path__ + "static/media/appdev.a43357a8.png";